import React from "react";
import PropTypes from "prop-types";
import { Box, Image, Text } from "@mantine/core";
import { useStylesLanding } from "../../utils/mantine/useStylesLanding";

const LearnMore = ({ staticBasePath, landingSectionRef }) => {
  const { classes: landingClasses } = useStylesLanding();
  const handleLearnMoreClick = () => {
    if (landingSectionRef.current) {
      const offsetTop =
        landingSectionRef.current.getBoundingClientRect().top +
        window.pageYOffset;
      setTimeout(() => {
        window.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        });
      }, 100);
    }
  };

  return (
    <Box className={landingClasses.learnMore} onClick={handleLearnMoreClick}>
      <Text component="span">Learn More</Text>
      <Image
        src={`${staticBasePath}public/images/svg/arrow_down.svg`}
        alt="Scroll down"
      />
    </Box>
  );
};
LearnMore.propTypes = {
  staticBasePath: PropTypes.string.isRequired,
  landingSectionRef: PropTypes.shape({
    current: PropTypes.shape({
      getBoundingClientRect: PropTypes.func.isRequired,
    }),
  }).isRequired,
};
export default LearnMore;
